import type { PanelMenuItem } from '@/components/menu/types';

export type BarChartViewMode = 'expand' | 'fit';

/** 「Zoomed view」: Fit と同型の虫眼鏡＋プラス（ズームイン） */
function BarViewExpandMenuIcon() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className="text-gray-500"
        >
            <circle cx="11" cy="11" r="8" />
            <path d="M21 21l-4.35-4.35" />
            <path d="M8 11h6" />
            <path d="M11 8v6" />
        </svg>
    );
}

/** 「Fit to view」側と対になるズームアウト（横線のみ＝マイナス） */
function BarViewFitMenuIcon() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className="text-gray-500"
        >
            <circle cx="11" cy="11" r="8" />
            <path d="M21 21l-4.35-4.35" />
            <path d="M8 11h6" />
        </svg>
    );
}

/**
 * パネルメニュー用: 現在が「全体」のときは「拡大」、現在が「拡大」のときは「全体」だけを表示する項目を返す。
 * 比率・スマホでは次が fit になる操作を出さない（「Fit to view」を表示しない）。
 */
export function buildBarChartViewModeMenuItem(params: {
    mode: BarChartViewMode;
    onChange: (next: BarChartViewMode) => void;
    labelExpand: string;
    labelFit: string;
    /** true かつ次のモードが fit のときは項目なし（スマホの比率積み上げ用） */
    suppressNextFitAction?: boolean;
}): PanelMenuItem | null {
    const next = params.mode === 'fit' ? 'expand' : 'fit';
    if (params.suppressNextFitAction && next === 'fit') {
        return null;
    }
    const label = next === 'expand' ? params.labelExpand : params.labelFit;
    return {
        key: 'bar-chart-view-mode',
        label,
        icon: next === 'expand' ? <BarViewExpandMenuIcon /> : <BarViewFitMenuIcon />,
        onClick: () => params.onChange(next),
    };
}
